module.exports = __webpack_public_path__ + "static/media/Elkwood.470cb655.ttf";